import { render, staticRenderFns } from "./BrokerPackage.vue?vue&type=template&id=4ece3de6&style=font-family%3AAlmarai&"
import script from "./BrokerPackage.vue?vue&type=script&lang=js&"
export * from "./BrokerPackage.vue?vue&type=script&lang=js&"
import style0 from "./BrokerPackage.vue?vue&type=style&index=0&id=4ece3de6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports